import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
import Vue from 'vue'
import Axios from 'axios'

const controller = 'Multiplo'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller

// Helpers privados de rota específica (observabilidade): POST /api/Multiplo/{acao} em vez de
// POST /api/Multiplo com "acao" no corpo. A rota já determina a Acao no backend. Não expostos
// diretamente aos consumidores — cada Acao migrada ganha seu próprio método nomeado abaixo.
const postRotaEspecifica = function (acao, dto) {
  dto = {
    ...dto,
  }
  var header = { headers: { acao: acao } }

  return util.Axios.Post(controller + '/' + acao, dto, header)
}
const postRotaEspecificaSemLoading = function (acao, dto) {
  const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }
  return Axios.post(url + '/' + acao, dto, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
}
// util.Axios.Put/Get não aceitam headers customizados (só controller/id) — para preservar o
// header "acao" e o comportamento com loading das rotas específicas que não são POST, replicamos
// aqui o mesmo padrão (addRequest + Authorization manual + Handle*) já usado por
// postRotaEspecificaSemLoading acima e por _core/controllers/dbs.js para chamadas via Axios cru.
const putRotaEspecifica = function (acao, dto) {
  util.store.commit('addRequest')
  const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }

  return Axios.put(url + '/' + acao, dto, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
}

const buildQueryString = function (query) {
  if (!query) return ''
  const usp = new URLSearchParams()
  Object.keys(query).forEach(key => {
    if (query[key] !== undefined && query[key] !== null) usp.append(key, query[key])
  })
  const qs = usp.toString()
  return qs ? '?' + qs : ''
}
const getRotaEspecifica = function (acao, path, query) {
  util.store.commit('addRequest')
  const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }
  const suffix = (path !== undefined && path !== null && path !== '') ? '/' + path : ''

  return Axios.get(url + '/' + acao + suffix + buildQueryString(query), { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
}
const deleteRotaEspecifica = function (acao, path, query) {
  util.store.commit('addRequest')
  const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }
  const suffix = (path !== undefined && path !== null && path !== '') ? '/' + path : ''

  return Axios.delete(url + '/' + acao + suffix + buildQueryString(query), { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
}

const deleteRotaEspecificaComBody = function (acao, dto) {
  util.store.commit('addRequest')
  const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }

  return Axios.delete(url + '/' + acao, { headers, data: dto }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
}

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Post: function (acao, dto) {
    dto = {
      ...dto,
    }
    var request = { acao: acao, Dto: dto }
    var header = { headers: { acao: acao } }

    return util.Axios.Post(controller, request, header)
  },
  Select: function (dto) {
    return postRotaEspecifica('Select', dto)
  },
  SelectPessoa: function (dto) {
    return postRotaEspecifica('SelectPessoa', dto)
  },
  CarregarDadosIniciais: function (dto) {
    return postRotaEspecifica('CarregarDadosIniciais', dto)
  },
  // Rotas específicas (observabilidade) — Lote 1
  ImportPropostaParticipante: function (dto) {
    return postRotaEspecifica('ImportPropostaParticipante', dto)
  },
  CalcularFluxoIrregular: function (dto) {
    return postRotaEspecifica('CalcularFluxoIrregular', dto)
  },
  PropostaAssinaturaFinalizadaCCB: function (dto) {
    return postRotaEspecifica('PropostaAssinaturaFinalizadaCCB', dto)
  },
  CreateUpdatePessoaSocios: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoaSocios', dto)
  },
  FGTSSaqAnivInclusaoProposta: function (dto) {
    return postRotaEspecifica('FGTSSaqAnivInclusaoProposta', dto)
  },
  IncluirPropostaGetContaParceiro: function (dto) {
    return postRotaEspecifica('IncluirPropostaGetContaParceiro', dto)
  },
  ReorderPropostaParticipante: function (dto) {
    return postRotaEspecificaSemLoading('ReorderPropostaParticipante', dto)
  },
  // Rotas específicas (observabilidade) — Lote 2
  FindRecordProdutoRede: function () {
    return getRotaEspecifica('FindRecordProdutoRede')
  },
  CreateUpdatePessoaEndereco: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoaEndereco', dto)
  },
  EnviarPropostaAnalise: function (dto) {
    return postRotaEspecifica('EnviarPropostaAnalise', dto)
  },
  CalculaGridParcelasSimplificado: function (dto) {
    return postRotaEspecifica('CalculaGridParcelasSimplificado', dto)
  },
  CalculaGridParcelasSimplificadoPrice: function (dto) {
    return postRotaEspecifica('CalculaGridParcelasSimplificadoPrice', dto)
  },
  ListProdutoRedeParcela: function () {
    return getRotaEspecifica('ListProdutoRedeParcela')
  },
  PropostaCancelar: function (dto) {
    return postRotaEspecifica('PropostaCancelar', dto)
  },
  ListVersaoCCB: function () {
    return getRotaEspecifica('ListVersaoCCB')
  },
  EnviarPropostaReanaliseManual: function (dto) {
    return postRotaEspecifica('EnviarPropostaReanaliseManual', dto)
  },
  IncluirPropostaManual: function (dto) {
    return postRotaEspecifica('IncluirPropostaManual', dto)
  },
  PropostaFinalizar: function (dto) {
    return postRotaEspecifica('PropostaFinalizar', dto)
  },
  PropostaAtualizarContaPagamento: function (dto) {
    return putRotaEspecifica('PropostaAtualizarContaPagamento', dto)
  },
  PropostaAprovar: function (dto) {
    return postRotaEspecifica('PropostaAprovar', dto)
  },
  PropostaLiberar: function (dto) {
    return postRotaEspecifica('PropostaLiberar', dto)
  },
  CreateUpdatePessoaQualificacao: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoaQualificacao', dto)
  },

  AgendaRecebivelConsultarDetalhes: function (dto) {
    return postRotaEspecifica('AgendaRecebivelConsultarDetalhes', dto)
  },
  BuscarSimulacaoFluxoIrregular: function (dto) {
    return postRotaEspecifica('BuscarSimulacaoFluxoIrregular', dto)
  },
  CalculaGridParcelasSimplificadoSAC: function (dto) {
    return postRotaEspecifica('CalculaGridParcelasSimplificadoSAC', dto)
  },
  CancelarParcelaAvulsaProposta: function (dto) {
    return postRotaEspecifica('CancelarParcelaAvulsaProposta', dto)
  },
  CancelarParcelasProposta: function (dto) {
    return postRotaEspecifica('CancelarParcelasProposta', dto)
  },
  CreateUpdatePessoa: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoa', dto)
  },
  CreateUpdatePessoaBanco: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoaBanco', dto)
  },
  CreateUpdatePessoaReferencia: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoaReferencia', dto)
  },
  CreateUpdatePessoaSocio: function (dto) {
    return postRotaEspecifica('CreateUpdatePessoaSocio', dto)
  },
  CreateUpdatePropostaDadosVeiculo: function (dto) {
    return postRotaEspecifica('CreateUpdatePropostaDadosVeiculo', dto)
  },
  CreateUpdatePropostaGarantiaBem: function (dto) {
    return postRotaEspecifica('CreateUpdatePropostaGarantiaBem', dto)
  },
  EnviarLogDeUsoDetalhe: function (dto) {
    return postRotaEspecifica('EnviarLogDeUsoDetalhe', dto)
  },
  EnviarPorEmailPropostaParcela: function (dto) {
    return postRotaEspecifica('EnviarPorEmailPropostaParcela', dto)
  },
  ExistePropostaPendente: function (dto) {
    return postRotaEspecifica('ExistePropostaPendente', dto)
  },
  FGTSSaqAnivBuscaSimulacao: function (dto) {
    return postRotaEspecifica('FGTSSaqAnivBuscaSimulacao', dto)
  },
  FinalizaAssinaturaCCB: function (dto) {
    return postRotaEspecifica('FinalizaAssinaturaCCB', dto)
  },
  GerarParcelasProposta: function (dto) {
    return postRotaEspecifica('GerarParcelasProposta', dto)
  },
  ImportarCCBDigitalAssinatura: function (dto) {
    return postRotaEspecifica('ImportarCCBDigitalAssinatura', dto)
  },
  IncluirNotaComercial: function (dto) {
    return postRotaEspecifica('IncluirNotaComercial', dto)
  },
  IncluirPropostaDadosVeiculos: function (dto) {
    return postRotaEspecifica('IncluirPropostaDadosVeiculos', dto)
  },
  IncluirPropostaManualSimplificado: function (dto) {
    return postRotaEspecifica('IncluirPropostaManualSimplificado', dto)
  },
  IncluirPropostaManualSimplificadoPrice: function (dto) {
    return postRotaEspecifica('IncluirPropostaManualSimplificadoPrice', dto)
  },
  InsertCCBDigitalAssinatura: function (dto) {
    return postRotaEspecifica('InsertCCBDigitalAssinatura', dto)
  },
  InsertCCBDigitalAssinaturas: function (dto) {
    return postRotaEspecifica('InsertCCBDigitalAssinaturas', dto)
  },
  ListProposta: function (dto) {
    return postRotaEspecifica('ListProposta', dto)
  },
  MarcarDocumentoNaoPendenteProposta: function (dto) {
    return postRotaEspecifica('MarcarDocumentoNaoPendenteProposta', dto)
  },
  PropostaAssinaturaCCB: function (dto) {
    return postRotaEspecifica('PropostaAssinaturaCCB', dto)
  },
  PropostaConferir: function (dto) {
    return postRotaEspecifica('PropostaConferir', dto)
  },
  PropostaListDetalhado: function (dto) {
    return postRotaEspecifica('PropostaListDetalhado', dto)
  },
  PropostaRecusar: function (dto) {
    return postRotaEspecifica('PropostaRecusar', dto)
  },
  RegistraPessoaOnBoarding: function (dto) {
    return postRotaEspecifica('RegistraPessoaOnBoarding', dto)
  },
  SaveProposta: function (dto) {
    return postRotaEspecifica('SaveProposta', dto)
  },
  SavePropostaAvalista: function (dto) {
    return postRotaEspecifica('SavePropostaAvalista', dto)
  },
  SavePropostaCampoAuxiliar: function (dto) {
    return postRotaEspecifica('SavePropostaCampoAuxiliar', dto)
  },
  SavePropostaParticipante: function (dto) {
    return postRotaEspecifica('SavePropostaParticipante', dto)
  },
  UploadDocumentoPessoa: function (dto) {
    return postRotaEspecifica('UploadDocumentoPessoa', dto)
  },
  UploadDocumentoProposta: function (dto) {
    return postRotaEspecifica('UploadDocumentoProposta', dto)
  },
  AtualizarCalculoFluxoIrregular: function (dto) {
    return putRotaEspecifica('AtualizarCalculoFluxoIrregular', dto)
  },
  AtualizarDadosPropostaFluxoIrregular: function (dto) {
    return putRotaEspecifica('AtualizarDadosPropostaFluxoIrregular', dto)
  },
  PropostaAtualizarCampoExtra: function (dto) {
    return putRotaEspecifica('PropostaAtualizarCampoExtra', dto)
  },
  PropostaAtualizarContaPagamentoEmDigitacao: function (dto) {
    return putRotaEspecifica('PropostaAtualizarContaPagamentoEmDigitacao', dto)
  },
  UpdatePropostaParticipantes: function (dto) {
    return putRotaEspecifica('UpdatePropostaParticipantes', dto)
  },
  RemoveCCBDigitalAssinaturas: function (dto) {
    return deleteRotaEspecificaComBody('RemoveCCBDigitalAssinaturas', dto)
  },
  RemovePropostaParticipanteVinculado: function (dto) {
    return deleteRotaEspecificaComBody('RemovePropostaParticipanteVinculado', dto)
  },
  SelectPessoaIntegracao: function () {
    return getRotaEspecifica('SelectPessoaIntegracao')
  },
  ListaProdutoRedeTipoContrato: function () {
    return getRotaEspecifica('ListaProdutoRedeTipoContrato')
  },

  FindRecordProposta: function (dto) {
    return getRotaEspecifica('FindRecordProposta', dto?.guidID)
  },
  FindRecordPessoa: function (dto) {
    return getRotaEspecifica('FindRecordPessoa', dto?.guidID)
  },
  FindRecordPessoaDadosContato: function (dto) {
    return getRotaEspecifica('FindRecordPessoaDadosContato', dto?.guidID)
  },
  FindRecordPessoaReferencia: function (dto) {
    return getRotaEspecifica('FindRecordPessoaReferencia', dto?.guidID)
  },
  FindRecordPessoaSocio: function (dto) {
    return getRotaEspecifica('FindRecordPessoaSocio', dto?.guidID)
  },
  FindRecordPropostaAvalista: function (dto) {
    return getRotaEspecifica('FindRecordPropostaAvalista', dto?.guidID)
  },
  FindRecordPropostaContaPagamento: function (dto) {
    return getRotaEspecifica('FindRecordPropostaContaPagamento', dto?.guidID)
  },
  FindRecordPropostaGarantiaBem: function (dto) {
    return getRotaEspecifica('FindRecordPropostaGarantiaBem', dto?.guidID)
  },
  FindPropostaCampoExtra: function (dto) {
    return getRotaEspecifica('FindPropostaCampoExtra', dto?.guidID)
  },
  ListRemessaPagamentoDetalhesPagosPorCodigoProposta: function (dto) {
    return getRotaEspecifica('ListRemessaPagamentoDetalhesPagosPorCodigoProposta', dto?.guidID)
  },
  ListAssinantesCCBDigitalAssinatura: function (dto) {
    return getRotaEspecifica('ListAssinantesCCBDigitalAssinatura', dto?.parameters?.[0]?.value)
  },
  ListPessoaBanco: function (dto) {
    return getRotaEspecifica('ListPessoaBanco', dto?.parameters?.[0]?.value)
  },
  ListPessoaQualificacao: function (dto) {
    return getRotaEspecifica('ListPessoaQualificacao', dto?.parameters?.[0]?.value)
  },
  ListPessoaReferencia: function (dto) {
    return getRotaEspecifica('ListPessoaReferencia', dto?.parameters?.[0]?.value)
  },
  ListPessoaSocio: function (dto) {
    return getRotaEspecifica('ListPessoaSocio', dto?.parameters?.[0]?.value)
  },
  ListPessoaEndereco: function (dto) {
    return postRotaEspecifica('ListPessoaEndereco', dto)
  },
  ListPropostaAvalista: function (dto) {
    return getRotaEspecifica('ListPropostaAvalista', dto?.parameters?.[0]?.value)
  },
  ListPropostaCampoAuxiliar: function (dto) {
    return getRotaEspecifica('ListPropostaCampoAuxiliar', dto?.parameters?.[0]?.value)
  },
  ListPropostaDadosVeiculo: function (dto) {
    return getRotaEspecifica('ListPropostaDadosVeiculo', dto?.parameters?.[0]?.value)
  },
  ListPropostaDocumento: function (dto) {
    return getRotaEspecifica('ListPropostaDocumento', dto?.parameters?.[0]?.value)
  },
  ListPropostaGarantiaBem: function (dto) {
    return getRotaEspecifica('ListPropostaGarantiaBem', dto?.parameters?.[0]?.value)
  },
  ListPropostaParcela: function (dto) {
    return getRotaEspecifica('ListPropostaParcela', dto?.parameters?.[0]?.value)
  },
  CarregarPropostaParticipantes: function (dto) {
    return getRotaEspecifica('CarregarPropostaParticipantes', dto?.parameters?.[0]?.value)
  },
  ConsultaProposta: function (dto) {
    return getRotaEspecifica('ConsultaProposta', dto?.dto?.CodigoProposta)
  },
  FGTSSaqAnivBuscaTaxas: function (dto) {
    return getRotaEspecifica('FGTSSaqAnivBuscaTaxas', dto?.dto?.CodigoProdutoRede)
  },
  PropostaRemoverDocumento: function (dto) {
    return deleteRotaEspecifica('PropostaRemoverDocumento', dto?.guidID)
  },
  RemoveCCBDigitalAssinatura: function (dto) {
    return deleteRotaEspecifica('RemoveCCBDigitalAssinatura', dto?.guidID)
  },
  RemovePessoaDocumento: function (dto) {
    return deleteRotaEspecifica('RemovePessoaDocumento', dto?.guidID)
  },
  RemovePessoaReferencia: function (dto) {
    return deleteRotaEspecifica('RemovePessoaReferencia', dto?.guidID)
  },
  RemovePessoaSocio: function (dto) {
    return deleteRotaEspecifica('RemovePessoaSocio', dto?.guidID)
  },
  RemovePropostaAvalista: function (dto) {
    return deleteRotaEspecifica('RemovePropostaAvalista', dto?.guidID)
  },
  RemovePropostaDadosVeiculo: function (dto) {
    return deleteRotaEspecifica('RemovePropostaDadosVeiculo', dto?.guidID)
  },
  RemoverPropostaGarantiaBem: function (dto) {
    return deleteRotaEspecifica('RemoverPropostaGarantiaBem', dto?.guidID)
  },
  // Ações com mais de um parâmetro / query string — extraem os campos do mesmo objeto que os
  // call sites já montam hoje (por nome, não por posição, para tolerar ordens diferentes).
  FindRecordPropostaParticipante: function (dto) {
    const inner = dto?.dto || {}
    return getRotaEspecifica('FindRecordPropostaParticipante', `${inner.codigoProposta}/${inner.codigo}`)
  },
  ListPessoaDocumentoByDtInclusaoProposta: function (dto) {
    const find = (n) => dto?.parameters?.find(p => p.name === n)?.value
    return getRotaEspecifica('ListPessoaDocumentoByDtInclusaoProposta', `${find('CodigoPessoa')}/${find('CodigoProposta')}`)
  },
  ListPropostaParticipante: function (dto) {
    const find = (n) => dto?.parameters?.find(p => p.name === n)?.value
    const agruparPorNivel = find('AgruparPorNivel')
    return getRotaEspecifica('ListPropostaParticipante', find('CodigoProposta'), agruparPorNivel !== undefined ? { agruparPorNivel } : undefined)
  },
  ConsultaPropostaEstendida: function (dto) {
    const est = dto?.dtoEstendida || {}
    return getRotaEspecifica('ConsultaPropostaEstendida', dto?.dto?.CodigoProposta, {
      carregarDadosVeiculo: est.CarregarDadosVeiculo,
      carregarDadosAnaliseDocumentos: est.CarregarDadosAnaliseDocumentos,
      carregarDadosAnaliseBMPCred: est.CarregarDadosAnaliseBMPCred,
      carregarGarantias: est.CarregarGarantias
    })
  },
  CalcularCamposProposta: function (arg) {
    const inner = arg?.dto || {}
    return getRotaEspecifica('CalcularCamposProposta', inner.codigoProposta, {
      usarJurosProposta: inner.usarJurosProposta,
      fluxoIrregular: inner.fluxoIrregular,
      nroDiasIntervaloPrazo: inner.nroDiasIntervaloPrazo,
      calculoGradesParcelas: inner.calculoGradesParcelas,
      montaFluxoPagamentoEstatico: inner.montaFluxoPagamentoEstatico
    })
  },
  ConsultaEmailAge: function (dto) {
    return getRotaEspecifica('ConsultaEmailAge', null, { email: dto?.consulta?.Email })
  },
  ConsultaLogPorPeriodo: function (dto) {
    const find = (n) => dto?.parms?.find(p => p.name === n)?.value
    const query = buildQueryString({
      periodoInicio: find('PeriodoInicio'),
      periodoFim: find('PeriodoFim'),
      documentoParceiro: find('DocumentoParceiro'),
      bureau: find('Bureau')
    })
    // Timeout próprio: sem ele a requisição pode ficar pendurada e o loading global nunca é liberado.
    // HandleErrorBase libera o loading (removeRequest) e devolve o erro do axios (isAxiosError) em vez de rejeitar.
    util.store.commit('addRequest')
    const headers = { acao: 'ConsultaLogPorPeriodo', Authorization: `Bearer ${getToken()}` }
    return Axios.get(url + '/ConsultaLogPorPeriodo' + query, { headers, timeout: 30000 })
      .then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
  ListCCBDigitalAssinatura: function (dto) {
    const find = (n) => dto?.parameters?.find(p => p.name === n)?.value
    const search = find('search')
    return getRotaEspecifica('ListCCBDigitalAssinatura', find('CodigoProposta'), search !== undefined ? { search } : undefined)
  },
  RemovePropostaParticipante: function (dto) {
    const find = (n) => dto?.parameters?.find(p => p.name === n)?.value
    const bloqueio = find('bloqueioAlteracaoCadastral')
    const solicitante = find('solicitanteAlteracaoCadastral')
    const query = {}
    if (bloqueio !== undefined) query.bloqueioAlteracaoCadastral = bloqueio === 'S'
    if (solicitante !== undefined) query.solicitanteAlteracaoCadastral = solicitante
    return deleteRotaEspecifica('RemovePropostaParticipante', dto?.guidID, Object.keys(query).length ? query : undefined)
  },
  PostFile: function (acao, dto) {
    var request = {}
    var header = {}
    request = { acao: acao, fileDto: dto }
    switch (acao) {
      case 'UploadDocumentoPessoa':
        header = { headers: { acao: acao } }
        break;
      case 'UploadDocumentoProposta':
        header = { headers: { acao: acao } }
        break;
      default:
        return 'Ação inválida para esse tipo de envio'
    }
    return util.Axios.Post(controller + '/PostWithFile', request, header)
  },
  PostSemLoading: function (acao, dto) {
    const request = { acao: acao, Dto: dto }
    const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }
    return Axios.post(url, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  convertDateTime (date) {
    var dataConvertida = ui.Format.Date(ui.Parse.Date(date), 'yyyy-MM-dd HH:mm:ss')
    return new Date(dataConvertida)
  },
  GetValuesBoleto: function (linhaDigitavel) {
    return util.Axios.Get(controller + '/GetValuesBoleto', linhaDigitavel)
  },
  GetCodigoParametro: function (id) {
    return util.Axios.Get(controller + '/GetCodigoParametro', id)
  },
  ValidaDadosIniciais (th, response) {
    let msg = 'Foram encontrados problemas no cadastro do cliente.'
    if (response.status === 'ERRO_CLIENTE') { msg = 'Cliente não cadastrado' } else if (response.status.indexOf('PROPOSTA_') >= 0) { msg = 'Já existem propostas cadastradas para esse cliente' } else if (response.status.indexOf('ERRO_CUSTOMIZACAO') >= 0) { msg = 'Falha na customização do cliente' } else if (response.status.indexOf('ERRO_LIMITE_CREDITO') >= 0) { msg = 'Falha ao carregar limite de crédito do cliente' }
    th.$api.UI.ShowError('Erro Cadastro Cliente', msg)
  },
  GerarCCB: function (id) {
    util.Axios.Get(controller + '/GerarCCB/' + id).then(function (response) {
      if (response?.error?.includes('Bad Request')) {
        ui.ShowAlert('Em Processamento', 'Tente novamente em alguns minutos')
      } else if (ui.PostLoadData(response, true)) {
        var a = document.createElement('a');
        a.href = `data:${response.type};base64,` + response.file;
        a.download = response.name;
        a.click();
      }
    })
  },
  GerarComprovantePagamento: function (id) {
    util.Axios.Get(controller + '/GerarComprovantePagamento/' + id).then(function (response) {
      if (ui.PostLoadData(response, true)) {
        var a = document.createElement('a');
        a.href = `data:${response.type};base64,` + response.file;
        a.download = response.name;
        a.click();
      }
    })
  },
  GetBoletosAgenda: function (codigoProposta) {
    if (!codigoProposta) {
      ui.ShowError('Erro', 'Necessário código da proposta para realizar o download.')
      return;
    }
    util.Axios.Get(controller + '/GetBoletosAgenda/' + codigoProposta).then(function (response) {
      if (ui.PostLoadData(response, true)) {
        if (!response.file || !response.name || !response.type) {
          ui.ShowError('Erro', 'Não foi possivel realizar o download dos Boletos')
          return;
        }

        const a = document.createElement('a');
        a.href = `data:${response.type};base64,${response.file}`;
        a.download = response.name;
        a.style.display = 'none';

        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          document.body.removeChild(a);
        }, 100);
      }
    })
  },
  GetPDF: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDF', dto)
  },
  gerarComprovante: function (dto) {
    return util.Axios.PostBlob(controller + '/gerarComprovante', dto)
  },
  GerarEmail: function (dto) {
    return util.Axios.Post(controller + '/GerarEmail', dto)
  },
  ClearConjuge (model) {
    if (model.EstadoCivil !== 2) {
      Vue.set(model, 'CPFConjuge', null)
      Vue.set(model, 'NomeConjuge', null)
      Vue.set(model, 'RGConjuge', null)
      Vue.set(model, 'TelefoneCelularConjuge', null)
      Vue.set(model, 'EmailConjuge', null)
      if (model.MostrarConjugeCCB) {
        Vue.set(model, 'MostrarConjugeCCB', null)
      }
    }
  },
  GetExcel: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarExcel', dto)
  },
  GetCsv: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarCsv', dto)
  },
  GetMotivosRejeicao (th) {
    this.Select({ filter: { tipoRegistro: 213 } }).then(response => {
      if (ui.PostLoadData(response) && response.JSON) {
        var motivosRejeicao = JSON.parse(response.JSON).filter(i => !i.Description.includes('INATIVO')).map((o) => {
          return { value: o.ID, text: o.Description }
        })
        th.$set(th, 'motivosRejeicao', motivosRejeicao)
      }
    })
  },
  async CarregaDadosPessoa (documento) {
    let dadosCarregados = {}
    const pessoa = await this.SelectPessoa({ filter: { tipoRegistro: 1, DocumentoCliente: ui.Format.SomenteAlfanumerico(documento) } })
    if (pessoa.JSON) {
      dadosCarregados = JSON.parse(pessoa.JSON)
      if (dadosCarregados.DocumentoFederal) {
        const dto = { parameters: [{ name: 'CodigoPessoa', value: dadosCarregados.Codigo }] }
        const endereco = await this.ListPessoaEndereco(dto)
        if (endereco && endereco.Data.length > 0) {
          dadosCarregados.PessoaDadosEndereco = endereco.Data[endereco.Data.length - 1]
          dadosCarregados.PessoaDadosEndereco.CEP = ui.Format.Cep(endereco.Data[endereco.Data.length - 1].CEP)
          dadosCarregados.PessoaDadosEndereco.NroLogradouro = ui.Format.Cep(endereco.Data[endereco.Data.length - 1].NroLogradouro)
        }
        const banco = await this.ListPessoaBanco(dto)
        if (banco && banco.Data.length > 0) {
          dadosCarregados.PessoaDadosBancarios = banco.Data[banco.Data.length - 1]
          dadosCarregados.PessoaDadosBancarios.Conta = banco.Data[banco.Data.length - 1].Conta + '-' + banco.Data[banco.Data.length - 1].ContaDig
          dadosCarregados.PessoaDadosBancarios.CodigoBanco = banco.Data[banco.Data.length - 1].CodigoBanco
          dadosCarregados.PessoaDadosBancarios.Banco = banco.Data[banco.Data.length - 1].BancoDescricao
        }
        return dadosCarregados
      }
    } else {
      return null
    }
  },
  async GetPortalByAmbiente (ambiente) {
    return util.Axios.Get(controller + '/GetPortalByAmbiente', ambiente)
  },
  MergeFiles: async function (dto) {
    const response = await util.Axios.Post(controller + '/MergeFiles', dto, { responseType: 'arraybuffer' })
    return response
  },
})
